import React, { memo, useState, useEffect } from 'react';
import { Stack, Card, Typography, Divider, Icon } from 'investira.react.components';
import MdEditor from './MdEditor';
import SugestaoCard from './SugestaoCard';
import QuestaoCardRating from './QuestaoCardRating';
import AvaliadoCheck from './AvaliadoCheck';
import { validators } from 'investira.sdk';

const QuestaoCard = memo(props => {
  const { id, data, activeQuestionId, aliasId, onSelect, value = {}, onChange } = props;
  const isSelected = Number(activeQuestionId) === id;

  const [markdown, setMarkdown] = useState('');
  const [rating, setRating] = useState(0);
  const [checked, setChecked] = useState(Boolean(value?.avaliado));

  // TODO: Adicionar um debounce para o autosave
  const handleMarkdownChange = (markdown, initialMarkdownNormalize) => {
    setMarkdown(markdown);
  };

  const hasJustificativa = !validators.isEmpty(String(markdown).trim());
  const hasRating = rating > 0;

  useEffect(() => {
    setChecked(Boolean(value?.avaliado));
  }, [id, value?.avaliado]);

  useEffect(() => {
    if (!hasJustificativa || !hasRating || checked) {
      return;
    }

    setChecked(true);
    onChange?.(id, {
      avaliado: true
    });
  }, [id, hasJustificativa, hasRating, checked, onChange]);

  const handleCheckedChange = pChecked => {
    setChecked(pChecked);
    onChange?.(id, {
      avaliado: pChecked
    });
  };

  return (
    <Card
      id={id}
      sx={{
        opacity: isSelected ? 1 : 0.7,
        ...(isSelected && { border: '1px solid', borderColor: 'primary.main' })
      }}
      raised={isSelected}
      onClick={() => onSelect(id)}>
      <Stack m={2}>
        <Stack mb={1} direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" gap={1} alignItems="center">
            <Typography variant="caption" color="textSecondary">
              Questão {aliasId}
            </Typography>
          </Stack>
        </Stack>

        <Stack mb={1}>
          <Typography variant="body1" color="textPrimary" sx={{ fontWeight: 600 }}>
            {data.questao}
          </Typography>
        </Stack>

        <>
          <Stack gap={1}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="caption" color="textSecondary">
                Justificativa
              </Typography>
            </Stack>
            <MdEditor
              id={id}
              onBlur={(e, id) => console.log(e, id)}
              isSelected={isSelected}
              onChange={handleMarkdownChange}
            />
          </Stack>
          <Stack mt={1}>
            <Divider />
            <Stack
              direction="row"
              alignItems="center"
              sx={{ minHeight: '40px' }}
              justifyContent={hasJustificativa ? 'space-between' : 'end'}>
              {/* {hasJustificativa && (
                <QuestaoCardRating
                  name={`rt-questao-${id}`}
                  rating={rating}
                  readOnly={!isSelected}
                  onChange={value => setRating(value)}
                />
              )} */}
              <AvaliadoCheck
                checked={checked}
                disabled={!isSelected}
                onChange={handleCheckedChange}
              />
            </Stack>
          </Stack>
        </>
      </Stack>
    </Card>
  );
});

export default QuestaoCard;
